// extracted by mini-css-extract-plugin
export default {"text":"Baners_text__QcalC","slick":"Baners_slick__IPxe8"};